/*
  PB Forged: rolling spec total and free photoshoot progress.

  Avis maintains its own running add-on total in #avp-productoption-totalpriceadd
  and hides it with its own apo-total-addcharge-hide class. That element is the
  source of truth for the add-on figure, because it covers every widget type
  (selects, swatch dropdowns, combos), not just the ones we can parse. It is also
  why the panel updates for the centre cap, which is a swatch and fires no
  change event.

  The shoot threshold counts TASTE upgrades only, so diameter is subtracted.
  Diameter is a fitment decision and cannot be nudged; finishes and caps can.
  That is the whole basis of the offer, see the Incentive strategy doc.

  PLACEMENT. The template can only place this block among product-info blocks,
  but the Avis options and the CTA both live INSIDE the product form, which is a
  later sibling block. Left alone the total renders above every question, where
  nobody can watch it change. So once Avis has rendered, the panel is moved into
  the form, directly above the wrapper holding buy-buttons. It carries no form
  inputs, so moving it inside the form changes nothing about submission.

  CTA LABEL. pb-forged-brief.js builds the button as
  CTA_LABEL + " · from " + price, which put a second, different price within
  100px of this panel (button "from £4,099" against panel "£4,299"). That file is
  minified, so the suffix is stripped here rather than rewritten there. Guarded
  so the write only happens when the text actually differs, which also stops the
  observer feeding itself.

  Nothing here writes to the cart. The figure is an estimate, deliberately
  labelled as such, because the firm price is set on the draft order after the
  design proof.
*/
(function () {
  var MOUNT = document.querySelector('[data-pb-quote]');
  if (!MOUNT) return;

  var BASE = parseInt(MOUNT.getAttribute('data-base'), 10);          // pennies
  var THRESHOLD = parseInt(MOUNT.getAttribute('data-threshold'), 10); // pennies
  if (isNaN(BASE)) return;
  if (isNaN(THRESHOLD)) THRESHOLD = 20000;

  var elTotal = MOUNT.querySelector('[data-pb-total]');
  var elBreak = MOUNT.querySelector('[data-pb-breakdown]');
  var elFill = MOUNT.querySelector('[data-pb-fill]');
  var elShoot = MOUNT.querySelector('[data-pb-shoot]');
  var elBar = MOUNT.querySelector('[data-pb-bar]');

  function money(pennies) {
    var n = pennies / 100;
    return '£' + n.toLocaleString('en-GB', {
      minimumFractionDigits: n % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function parseCharge(text) {
    // Matches the "(+£200.00)" Avis appends to a priced option label.
    var m = /\(\+\s*£\s*([\d,]+(?:\.\d{1,2})?)\s*\)/.exec(text || '');
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
  }

  function avisAddOn() {
    var el = document.getElementById('avp-productoption-totalpriceadd');
    if (!el) return 0;
    var m = /([\d,]+(?:\.\d{1,2})?)/.exec(el.textContent || '');
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
  }

  function diameterCharge() {
    // Diameter groups are plain selects named "Front diameter" / "Rear diameter".
    // Matched loosely so a rename to "Wheel diameter" or "Front wheel size" still works.
    var sum = 0;
    [].forEach.call(document.querySelectorAll('select'), function (s) {
      var name = (s.getAttribute('name') || s.id || '');
      if (!/diameter|wheel\s*size/i.test(name)) return;
      var opt = s.options[s.selectedIndex];
      if (opt) sum += parseCharge(opt.text);
    });
    return sum;
  }

  var moved = false;
  function place() {
    if (moved) return;
    var buy = document.querySelector('.buy-buttons');
    if (!buy) return;
    var anchor = buy.parentElement;
    if (!anchor || !anchor.parentElement) { anchor = buy; }
    if (anchor.parentElement && anchor.previousElementSibling !== MOUNT) {
      anchor.parentElement.insertBefore(MOUNT, anchor);
    }
    moved = true;
  }

  // Strip the " · from £X,XXX" suffix pb-forged-brief.js appends to the CTA.
  var CTA_PRICE = /\s*[·•]\s*from\s*£\s*[\d,]+(?:\.\d{1,2})?\s*$/i;
  function stripCtaPrice() {
    var btn = document.querySelector('[data-pb-cta]') ||
              document.querySelector('.buy-buttons button');
    if (!btn) return;
    var target = btn.querySelector('span, .button__text') || btn;
    var current = target.textContent || '';
    var cleaned = current.replace(CTA_PRICE, '').trim();
    if (cleaned && cleaned !== current.trim()) target.textContent = cleaned;
  }

  function watchCta() {
    var buy = document.querySelector('.buy-buttons');
    if (!buy) return;
    new MutationObserver(stripCtaPrice).observe(buy, {
      childList: true, characterData: true, subtree: true
    });
    stripCtaPrice();
  }

  function render() {
    var addOn = avisAddOn();
    var diameter = diameterCharge();
    var upgrades = Math.max(0, addOn - diameter);
    var total = BASE + addOn;

    elTotal.textContent = money(total);

    if (addOn > 0) {
      elBreak.textContent = money(BASE) + ' base plus ' + money(addOn) + ' of options';
    } else {
      elBreak.textContent = 'Base specification. Options add to this as you choose them.';
    }

    var pct = Math.min(100, Math.round((upgrades / THRESHOLD) * 100));
    elFill.style.width = pct + '%';
    elBar.setAttribute('aria-valuenow', String(pct));

    if (upgrades >= THRESHOLD) {
      MOUNT.setAttribute('data-unlocked', 'true');
      elShoot.textContent = 'Included: a professional photoshoot of your car once the wheels are fitted, and the full set of images to keep.';
    } else {
      MOUNT.removeAttribute('data-unlocked');
      elShoot.textContent = money(THRESHOLD - upgrades) + ' more on finishes or a centre cap and we will shoot your car professionally once the wheels are fitted, free. Diameter does not count towards this.';
    }
  }

  // Avis rewrites its total asynchronously after each change, so observe it
  // rather than listening for change events we might not be bound to.
  function watch() {
    var el = document.getElementById('avp-productoption-totalpriceadd');
    if (!el) return false;
    place();
    watchCta();
    new MutationObserver(render).observe(el, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(render, 120); }, true);
    render();
    return true;
  }

  if (!watch()) {
    // Avis injects late on some loads. Poll briefly, then give up quietly
    // leaving the server-rendered base price in place.
    var tries = 0;
    var timer = setInterval(function () {
      if (watch() || ++tries > 40) clearInterval(timer);
    }, 250);
  }
})();
